import { render } from "./termsConditionView.vue?vue&type=template&id=29f00bf4"
import script from "./termsConditionView.vue?vue&type=script&lang=js"
export * from "./termsConditionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__